/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Waiver_CheckboxInputs */

const en_label_waiver_checkbox = /** @type {(inputs: Label_Waiver_CheckboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I have read and agree to the terms, conditions, and waiver above.`)
};

const es_label_waiver_checkbox = /** @type {(inputs: Label_Waiver_CheckboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`He leído y acepto los términos, condiciones y la exención de responsabilidad anterior.`)
};

const fr_label_waiver_checkbox = /** @type {(inputs: Label_Waiver_CheckboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J'ai lu et j'accepte les conditions générales et la décharge ci-dessus.`)
};

const de_label_waiver_checkbox = /** @type {(inputs: Label_Waiver_CheckboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich habe die oben genannten Bedingungen und die Verzichtserklärung gelesen und stimme zu.`)
};

const id_label_waiver_checkbox = /** @type {(inputs: Label_Waiver_CheckboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saya telah membaca dan menyetujui syarat, ketentuan, dan pembebasan di atas.`)
};

/** @type {(inputs: Label_Waiver_CheckboxInputs) => LocalizedString} */
const ja_label_waiver_checkbox = en_label_waiver_checkbox;

/** @type {(inputs: Label_Waiver_CheckboxInputs) => LocalizedString} */
const zh_label_waiver_checkbox = en_label_waiver_checkbox;

/** @type {(inputs: Label_Waiver_CheckboxInputs) => LocalizedString} */
const ar_label_waiver_checkbox = en_label_waiver_checkbox;

/** @type {(inputs: Label_Waiver_CheckboxInputs) => LocalizedString} */
const it_label_waiver_checkbox = en_label_waiver_checkbox;

/** @type {(inputs: Label_Waiver_CheckboxInputs) => LocalizedString} */
const ru_label_waiver_checkbox = en_label_waiver_checkbox;

/** @type {(inputs: Label_Waiver_CheckboxInputs) => LocalizedString} */
const pt_label_waiver_checkbox = en_label_waiver_checkbox;

/** @type {(inputs: Label_Waiver_CheckboxInputs) => LocalizedString} */
const ko_label_waiver_checkbox = en_label_waiver_checkbox;

/**
* | output |
* | --- |
* | "I have read and agree to the terms, conditions, and waiver above." |
*
* @param {Label_Waiver_CheckboxInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_waiver_checkbox = /** @type {((inputs?: Label_Waiver_CheckboxInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Waiver_CheckboxInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_waiver_checkbox(inputs)
	if (locale === "es") return es_label_waiver_checkbox(inputs)
	if (locale === "fr") return fr_label_waiver_checkbox(inputs)
	if (locale === "de") return de_label_waiver_checkbox(inputs)
	if (locale === "ja") return ja_label_waiver_checkbox(inputs)
	if (locale === "zh") return zh_label_waiver_checkbox(inputs)
	if (locale === "ar") return ar_label_waiver_checkbox(inputs)
	if (locale === "id") return id_label_waiver_checkbox(inputs)
	if (locale === "it") return it_label_waiver_checkbox(inputs)
	if (locale === "ru") return ru_label_waiver_checkbox(inputs)
	if (locale === "pt") return pt_label_waiver_checkbox(inputs)
	return ko_label_waiver_checkbox(inputs)
});